// Previously uncatalogued fallback strings used by customer-facing screens.
window.PlummeI18n.register('no', {
  "common.rowUnavailable": "Dataene kunne ikke lastes. Pr?v igjen.",
  "common.rowContextChanged": "Valgt foretak eller dokument er endret. ?pne det p? nytt.",
  "common.bankStatementIncomplete": "Bankutskriften er ikke ferdig lastet. Pr?v igjen.",
  "common.journalProofUnavailable": "Regnskapsgrunnlaget kunne ikke bekreftes.",

  'pay.employeesAwaitingPayment': '{{count}} ansatte venter på utbetaling',
  'pay.readyForPayment': 'Klar til utbetaling',
  'pay.readyForPaymentHelp': 'Godkjente og bokførte lønnskjøringer som fortsatt har lønn som ikke er registrert utbetalt.',
  'pay.noRunsAwaitingPayment': 'Ingen lønnskjøringer venter på utbetaling',
  'pay.noRunsAwaitingPaymentHint': 'Godkjente lønnskjøringer vises her frem til utbetalingen er registrert.',
  'pay.draftPayrollRuns': 'Utkast',
  'pay.noDraftPayrollRuns': 'Ingen lønnsutkast.',
  'buy.ownerOutlay': 'Utlegg fra eier',
  'home.followup.assetPostingTitle': 'Avskrivninger',
  'home.followup.assetPostingAction': 'Se avvik',
  'home.followup.assetPostingIssue': 'Automatisk avskrivning trenger oppfølging. Kontroller eiendelens plan eller kontakt support. Plumme prøver igjen når avviket er rettet.',
  "ui.cancel": "Avbryt",
  "ui.close": "Lukk",
  "ui.back": "Tilbake",
  "ui.continue": "Fortsett",
  "ui.open": "Åpne",
  "app.close": "Lukk",
  'common.loadMore': 'Last inn flere', "common.loading": "Laster...",
  "shell.collapse": "Kollaps meny",
  "chat.cardFromFirm": "Regnskapsføreren skrev",
  "chat.cardFromYou": "Du skrev",
  "chat.cardNone": "Ingen meldinger ennå",
  "chat.firm": "Regnskapsføreren din",
  "chat.helpTitle": "Regnskapsføreren din",
  "chat.help": "Skriv direkte til regnskapsføreren din. Bare du som eier eller administrator ser denne samtalen.",
  "chat.cardOpenUnread": "Les meldingen",
  "chat.cardOpen": "Send en melding",
  "chat.modalTitle": "Du har en ulest melding",
  "chat.modalOpen": "Åpne chat",
  "chat.modalBody": "har sendt deg en melding du ikke har lest.",
  "chat.client": "Klienten",
  "chat.subFirm": "Dialog med klienten",
  "chat.subClient": "Dialog med regnskapsføreren din",
  "chat.emptyFirm": "Ingen meldinger ennå. Skriv til klienten her — de ser den i Plumme.",
  "chat.emptyClient": "Ingen meldinger ennå. Spør regnskapsføreren din om hva du lurer på.",
  "chat.placeholder": "Skriv en melding …",
  "chat.send": "Send",
  "rf.client.takeoverSaved": "Overtakelsesdatoen er lagret",
  "rf.client.takeover": "Overtakelsesdato",
  "rf.client.takeoverHelp": "Perioder og frister før denne datoen regnes ikke som byråets arbeid. Klientens egen plikt endres ikke.",
  "rf.client.takeoverSave": "Lagre dato",
  "clo.cash.invalidAmount": "Skriv inn opptalt kontantbeholdning.",
  "clo.cash.documentationRequired": "Beskriv dokumentasjonen for opptellingen før du godkjenner.",
  "clo.cash.saved": "Kontantopptellingen er lagret.",
  "clo.cash.saveError": "Kunne ikke lagre kontantopptellingen.",
  "clo.cash.title": "Mynter og sedler",
  "clo.cash.readySubtitle": "Kontantbeholdningen er opptalt og stemmer med konto 1900.",
  "clo.cash.naSubtitle": "Ingen kontantbeholdning er registrert på konto 1900.",
  "clo.cash.todoSubtitle": "Tell kontantbeholdningen per 31.12 og sammenlign med konto 1900.",
  "clo.cash.noStatus": "Kontantstatus er ikke beregnet ennå.",
  "clo.cash.booked": "Bokført på 1900",
  "clo.cash.counted": "Opptalt per 31.12",
  "clo.cash.difference": "Differanse",
  "clo.cash.countedField": "Opptalt kontantbeholdning",
  "clo.cash.account": "Kontantkonto",
  "clo.cash.documentation": "Dokumentasjon for opptellingen",
  "clo.cash.documentationPlaceholder": "For eksempel: Kasse opptalt 31.12 av daglig leder. Opptellingsskjema er lagret i bilagsmappen.",
  "clo.cash.noDifferenceHelp": "Når opptalt beholdning stemmer med konto 1900, lagres opptellingen som dokumentasjon uten ekstra postering.",
  "clo.cash.surplusHelp": "Differansen øker konto 1900 og føres mot annen inntekt.",
  "clo.cash.shortageHelp": "Differansen reduserer konto 1900 og føres mot annen kostnad.",
  "clo.cash.approve": "Godkjenn opptelling",
  "clo.chart.suggestionsReady": "Forslagene er klare til godkjenning.",
  "clo.chart.noSuggestions": "Fant ingen sikre forslag.",
  "clo.chart.pickBeforeApprove": "Velg standardkonto før du godkjenner.",
  "clo.chart.saved": "{{count}} kontokoblinger lagret",
  "clo.chart.saveError": "Kunne ikke lagre kontokoblingene.",
  "clo.chart.title": "Kontoplan",
  "clo.chart.missingSubtitle": "{{count}} egne kontoer mangler kobling til standardkonto.",
  "clo.chart.readySubtitle": "Kontoplanen er klar for årsavslutning.",
  "clo.chart.allMapped": "Alle egendefinerte kontoer er koblet til standardkonto.",
  "clo.chart.instructions": "Velg hvilken standardkonto hver egen konto tilsvarer.",
  "clo.chart.aiSuggest": "AI finner forslag",
  "clo.chart.accountFallback": "Konto {{code}}",
  "clo.chart.missingMapping": "Mangler standardkobling",
  "clo.chart.equivalent": "Tilsvarer standardkonto",
  "clo.chart.reset": "Nullstill forslag",
  "clo.chart.approve": "Godkjenn {{count}} forslag",
  "clo.share.title": "Aksjekapital",
  "clo.share.readySubtitle": "Aksjekapitalen er bokført på konto 2000.",
  "clo.share.missingSubtitle": "Kontroller eller bokfør aksjekapitalen før årsoppgjøret fullføres.",
  "clo.share.noStatus": "Aksjekapitalstatus er ikke beregnet ennå.",
  "clo.share.booked": "Bokført på 2000",
  "clo.share.minimum": "Minimum for norsk AS",
  "clo.share.lossNote": "Underskudd eller tapt egenkapital skal normalt ikke føres bort fra konto 2000. Det vurderes i egenkapital, resultatdisponering og fortsatt drift. Dette punktet sjekker bare at registrert aksjekapital er bokført som kredit på 2000.",
  "clo.share.freePosting": "Bokfør aksjekapital"
});

// Shared labels must be available before any route-specific catalog loads.
window.PlummeI18n.register('no', {
  "sharedText.app.employeePortalVerifyTitle": "Bekreft e-postadressen din",
  "sharedText.auth.remember": "Husk meg",
  "sharedText.auth.noAccount": "Har du ikke konto?",
  "sharedText.auth.forgotCopy": "Skriv inn e-posten du logger inn med, så sender vi deg en lenke for å lage et nytt passord.",
  "sharedText.acc.sentLinkTo": "Vi har sendt en lenke til",
  "sharedText.rep.export.year": "År",
  "sharedText.bank.previewVoucher": "Forhåndsvis bilaget",
  "sharedText.km.returnTrip": "Tur/retur",
  "sharedText.pay.paidOut": "Utbetalt",
  "sharedText.inv.col.net": "Netto",
  "sharedText.transaction.by": "av",
  "sharedText.buy.pickCategory": "Konto/kategori",
  "sharedText.vat.vat": "MVA",
  "sharedText.sup.seeVoucher": "Se bilag",
  "sharedText.bwf.correctEntry": "Korriger postering",
  "sharedText.ap.approve": "Godkjenn",
  "sharedText.sale.pay.partialStatusRemaining": "gjenstår",
  "sharedText.helpTopics.ocrCorrection.title": "Korriger avlesning",
  "sharedText.pay.note": "Notat",
  "sharedText.bank.openingBalance": "Inngående saldo",
  "sharedText.asset.closing": "Utgående saldo",
  "sharedText.sale.att.dropHere": "Slipp bilaget her",
  "sharedText.voucher.pickAccount": "Velg konto",
  "sharedText.adv.scn.plan.interest": "Renter",
  "sharedText.sale.pay.fee": "Gebyr",
  "sharedText.ui.cancel": "Avbryt",
  "sharedText.bwf.selectLine": "Velg banklinje",
  "sharedText.bg.bankLines": "Banklinjer",
  "sharedText.home.ana.ring": "Fordeling",
  "sharedText.pj.row.new": "Ny rad",
  "sharedText.bank.bankLine": "Banklinje",
  "sharedText.helpTopics.openItem.title": "Åpen post",
  "sharedText.clo.amount": "Beløp",
  "sharedText.adv.status.more": "Flere valg",
  "sharedText.inboxStatus.dropReceipts": "Slipp bilagene her",
  "sharedText.bank.uploading": "Laster opp …",
  "sharedText.set.showAll": "Vis alle",
  "sharedText.bank.voucherReceivedOn": "Bilag mottatt på",
  "sharedText.set.acc.lines": "linjer",
  "sharedText.nav.budget": "Budsjett",
  "sharedText.bud.actual": "Faktisk",
  "sharedText.ui.close": "Lukk",
  "sharedText.pay.signOut": "Logg ut",
  "sharedText.rf.group.firm": "Regnskapsfører",
  "sharedText.rf.create.title": "Opprett regnskapsbyrå",
  "sharedText.ui.open": "Åpne",
  "sharedText.buy.next": "Neste",
  "sharedText.adv.docs.hide": "Skjul",
  "sharedText.fe.decline": "Avslå",
  "sharedText.common.yes": "Ja",
  "sharedText.ap.review.checked": "Kontrollert",
  "sharedText.clo.pick": "Velg",
  "sharedText.nav.taxReturn": "Skattemelding",
  "sharedText.clo.financialYear": "Regnskapsåret",
  "sharedText.helpTopics.residualValue.title": "Restverdi",
  "sharedText.clo.inventoryReview.undecided": "Velg vurdering",
  "sharedText.helpTopics.readyForUse.title": "Klar til bruk",
  "sharedText.asset.work.residualValue": "Forventet restverdi",
  "sharedText.inv.credit.line": "Linje",
  "sharedText.buy.paid": "Betalt",
  "sharedText.km.from": "Fra",
  "sharedText.km.to": "Til",
  "sharedText.set.accountNo": "Kontonr.",
  "sharedText.sale.credit.previewReason": "Årsak:",
  "sharedText.clo.description": "Beskrivelse",
  "sharedText.prd.price": "Pris",
  "sharedText.clo.sum": "Sum",
  "sharedText.inv.kpi.sub.exVat": "Eks. MVA",
  "sharedText.set.page": "Side",
  "sharedText.sale.cust.org": "Org.nr",
  "sharedText.trv.vehicle": "Kjøretøy",
  "sharedText.ap.monthControl.finding.deviation": "Mulig avvik",
  "sharedText.vat.cancel": "Annuller",
  "sharedText.bank.review": "Kontroller",
  "sharedText.inbox.supplierInvoice": "Leverandørfaktura",
  "sharedText.bank.roundingHelp": "Bruk bare dette for en reell liten avrundingsforskjell. Beløpet bokføres uten MVA mot",
  "sharedText.trv.reason": "Begrunnelse",
  "sharedText.set.acc.vatRegisteredPick": "Velg svar",
  "sharedText.set.acc.vatRegisteredUnknown": "Vet ikke",
  "sharedText.set.acc.vatRegisteredFrom": "MVA-registrert fra",
  "sharedText.vat.due": "Frist",
  "sharedText.pay.advance": "Forskudd",
  "sharedText.pay.aga": "AGA",
  "sharedText.inv.col.number": "Nr",
  "sharedText.onb.createPersonal": "Opprett din private økonomi",
  "sharedText.onb.createPersonalHelp": "Dette lager en egen privatøkonomi-bruker som du finner fra Min side og brukervelgeren.",
  "sharedText.onb.noBankData": "Bankkobling er ikke aktiv ennå. Du kan laste opp kontoutskrifter manuelt når du ønsker det.",
  "sharedText.po.youHaveStated": "Du har oppgitt at",
  "sharedText.po.wealthStrongestOn": "Formuen din scorer sterkest på",
  "sharedText.po.withYourAssumptions": "Med forutsetningene du har lagt inn, endrer formuen din seg med omtrent",
  "sharedText.po.splitIsEven": "Fordelingen er jevn. Dere deler",
  "sharedText.po.householdHasRegistered": "Husholdningen har registrert",
  "sharedText.po.budgetTotal": "Sum budsjett:",
  "sharedText.set.bank.typeTax": "Skattetrekk",
  "sharedText.clo.no": "Nei",
  "sharedText.po.showingScenario": "Viser scenario:",
  "sharedText.po.desiredNetWealth": "Ønsket nettoformue",
  "sharedText.po.lastsUntilYouAre": "varer til du er",
  "sharedText.sd.transition.years": "år",
  "sharedText.po.lasts": "varer",
  "sharedText.po.prioritise": "Prioriter",
  "sharedText.adv.scn.loan.monthsUnit": "mnd",
  "sharedText.po.doYouWantToDelete": "Vil du slette",
  "sharedText.po.householdSpends": "Husholdningen bruker",
  "sharedText.po.iRecommend": "Jeg anbefaler",
  "sharedText.po.debtFree": "Gjeldfri",
  "sharedText.po.interestPostedAs": "Renter og avdrag på dette lånet føres som",
  "sharedText.helpTopics.buffer.title": "Likvid buffer",
  "sharedText.clo.save": "Lagre",
  "sharedText.adv.profile.buffer": "Ønsket buffer",
  "sharedText.home.legend.income": "Inntekt",
  "sharedText.set.bank.typeSavings": "Sparing",
  "sharedText.pay.category": "Kategori",
  "sharedText.set.account": "Konto",
  "sharedText.po.allAccounts": "Alle kontoer",
  "sharedText.adv.status.snooze7": "Minn meg om en uke",
  "sharedText.po.yourHealthScoreIs": "Helsescoren din er",
  "sharedText.po.outOf100": "av 100",
  "sharedText.po.taxAssistant": "Skattemeldingsassistent",
  "sharedText.cust.prev": "Forrige",
  "sharedText.bank.finishReview": "Fullfør gjennomgang",
  "sharedText.po.checkBasis": "Kontrollgrunnlag",
  "sharedText.clo.name": "Navn",
  "sharedText.set.text": "Tekst",
  "sharedText.sale.textLine.boldShort": "F",
  "sharedText.sale.textLine.italicShort": "K",
  "sharedText.sale.lines.useDivider": "Bruk skillelinje",
  "sharedText.sale.textLine.dividerHint": "Vis linje under teksten i dokumentet.",
  "sharedText.nav.products": "Produkter",
  "sharedText.sale.textLine.titleNewText": "Ny tekstlinje",
  "sharedText.prd.deleted": "Slettet",
  "sharedText.pay.edit": "Rediger",
  "sharedText.clo.delete": "Slett",
  "sharedText.set.loans.startDate": "Startdato",
  "sharedText.helpTopics.unitCost.title": "Kostpris per enhet",
  "sharedText.pay.optional": "Valgfritt",
  "sharedText.registry.group": "Produktgruppe",
  "sharedText.clo.add": "Legg til",
  "sharedText.ha.products.account": "Inntektskonto",
  "sharedText.clo.accountNumber": "Kontonummer",
  "sharedText.clo.accountName": "Kontonavn",
  "sharedText.buy.supplierNew": "Ny leverandør",
  "sharedText.auth.createAccount": "Opprett konto",
  "sharedText.set.acc.equivalent": "Tilsvarer konto",
  "sharedText.bwf.entry": "Postering",
  "sharedText.sale.att.upload": "Last opp vedlegg",
  "sharedText.vat.settlement": "Oppgjør",
  "sharedText.ap.agent.invoice.selectRow": "Velg faktura",
  "sharedText.ap.workspace.treatmentAsset": "Registrer som driftsmiddel",
  "sharedText.bank.receiptLinked": "Koblet til banklinje",
  "sharedText.sd.documents.count": "dokumenter",
  "sharedText.set.debit": "Debet",
  "sharedText.set.bank.accounts": "Bankkontoer",
  "sharedText.sd.deleteBusinessHelp": "Slett foretak fjerner valgt foretak etter 30 dager via backend. Dette er en alvorlig handling.",
  "sharedText.vat.rate": "Sats",
  "sharedText.inv.bulk.noEmail": "mangler e-post",
  "sharedText.trv.privateRefundOf": "Privat refusjon på",
  "sharedText.asset.group": "Gruppe",
  "sharedText.asset.opening": "Inngående",
  "sharedText.asset.movements": "Bevegelser",
  "sharedText.set.credit": "Kredit",
  "sharedText.voucher.backToVat": "Tilbake til MVA-meldingen",
  "sharedText.vat.vatCode": "MVA-kode",
  "sharedText.bank.markVoucherLostTitle": "Marker bilag som borte",
  "sharedText.bank.voucherLostReason": "Forklaring",
  "pay.salaryLineDeleted": "Lønnslinjen er slettet.",
  "pay.salaryLineNotFound": "Lønnslinjen finnes ikke lenger.",
  "pay.deleteSalaryLine": "Slett lønnslinje",
  "pay.deleteSalaryLineConfirm": "Vil du slette «{{name}}» fra dette lønnsutkastet?",
  "pay.accountingVouchers": "Regnskapsbilag",
  "pay.payrollVoucher": "Lønnsbilag",
  "pay.paymentVoucher": "Betalingsbilag",
  "pay.paymentVoucherInDifferentYear": "Betalingen er bokført i {{year}} og vises derfor i saldobalansen for det året.",
  "pay.settleSalaryLiability": "Oppgjør av skyldig lønn",
  "pay.settleEmployeeExpense": "Oppgjør av utlegg",
  "pay.paymentFromBank": "Utbetaling fra bankkonto"
});
